var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScissor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m33.81 8.13l-2.18-1.65a1.92 1.92 0 0 0-2.36 0L10 22.06a5.46 5.46 0 1 0 2 1.81l3.9-3.12l13.37 10.77a1.92 1.92 0 0 0 2.36 0l2.18-1.64L20.94 19ZM7.45 29.75a2.86 2.86 0 1 1 2.86-2.86a2.87 2.87 0 0 1-2.86 2.86Z",
    className: "clr-i-solid clr-i-solid-path-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M14.3 15.24L12 13.38a5.46 5.46 0 1 0-2 1.81L12.16 17Zm-6.85-2a2.86 2.86 0 1 1 2.86-2.86a2.86 2.86 0 0 1-2.86 2.85Z",
    className: "clr-i-solid clr-i-solid-path-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v36H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissor);
export default __webpack_public_path__ + "static/media/scissor.c82be4f765c819d853b69905225597f1.svg";
export { ForwardRef as ReactComponent };